module.exports = __webpack_public_path__ + "img/logo.fac4bc8b.png";